define('order_wizard_paymentmethod_giftcertificates_module.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('order_wizard_paymentmethod_giftcertificates_module', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\r\n";
},"useData":true}, 'extensions/FinisSwim/B2C_Theme_Finis_2025/25.2.0/', 'extensions/FinisSwim/B2C_Theme_Finis_2025/25.2.0/', Handlebars);
});